import React from 'react';

import UserChallengeAnswers from '@/components/UserChallengeAnswers';
import useMostRecentChallengeResponse from '@/hooks/useMostRecentChallengeResponse';
import { Typography } from '@/ui';
import Spinner from '@/ui/components/Spinner';
import { DualTime } from '@/ui/DualTime';

import type { Props } from './types';

// Matches Typography's `body` + `muted` combo, for components that only take a className.
const mutedBodyClassName =
  'text-sm leading-relaxed text-uniform-gray-600 dark:text-uniform-gray-400';

const MostRecentChallengeResponse = ({ personId }: Props) => {
  const { data, isError, isPending } = useMostRecentChallengeResponse(personId);
  const userChallenge = data;

  return (
    <>
      {isPending ? (
        <div className="mt-2 flex justify-center py-4">
          <Spinner label="Loading last challenge response" />
        </div>
      ) : isError ? (
        <Typography className="mt-2 text-uniform-red-600 dark:text-uniform-red-500">
          Unable to load the last challenge response.
        </Typography>
      ) : !userChallenge ? (
        <Typography className="mt-2" muted>
          No completed challenges.
        </Typography>
      ) : (
        <>
          <div className="mt-2 flex items-baseline justify-between gap-2">
            <Typography weight="bold">{userChallenge.challenge?.title}</Typography>

            {!!userChallenge.finished_at && (
              <DualTime
                className={mutedBodyClassName}
                dateTime={new Date(userChallenge.finished_at)}
              />
            )}
          </div>

          <UserChallengeAnswers
            collapsible
            freeformFirst
            hideImages
            answers={userChallenge.answers}
          />
        </>
      )}
    </>
  );
};

export default React.memo(MostRecentChallengeResponse);
